import React, { Component } from 'react';

import {  getUser, setLang } from '../Actions/UserActions';
import { slide as Menu } from 'react-burger-menu'

import { connect } from 'react-redux';


import {NavLink} from "react-router-dom";

class NavBar2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: '',
            lang: navigator.language || navigator.userLanguage,
            setLang:"en"
        };

        this.setLang=this.setLang.bind(this)
    }
    componentWillMount() {

        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            this.setState({ setLang: "zh"});
        }else{
            this.setState({ setLang: "en"});
        }
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };



setLang(lang){
    this.setState({ setLang: lang});

    this.props.setLang(lang)
}

    renderMenu() {
        var styles = {
            bmBurgerButton: {
                position: 'absolute',
                width: '30px',
                height: '24px',
                left: '10px',
                top: '5px'
            },
            bmBurgerBars: {
                background: 'FireBrick'
            },
            bmCrossButton: {
                height: '24px',
                width: '24px'
            },
            bmCross: {
                background: "FireBrick"
            },
            bmMenu: {
                background: 'white',
                padding: '2.5em 1.5em 0',
                fontSize: '1.15em'
            },
            bmMorphShape: {
                fill: "FireBrick"
            },
            bmItemList: {
                color: 'black',
                padding: '0.8em',
                display: 'block'
            },
            bmItem: {
                display: 'block'
            },
            bmOverlay: {
                background: 'rgba(0, 0, 0, 0.3)'
            }
        }






//
        return(
            <div style={{ padding: 0, width:"100%"}}>




                {this.state.setLang==="en" &&  <div> {this.state.width<500 && <div  style={{margin:"auto", display: "flex"}}>

                    <Menu styles={ styles } >
                        <div> <NavLink activeStyle={{color: "FireBrick"}} to={`/home`}>Home </NavLink></div>
                        <div> <NavLink activeStyle={{color: "FireBrick"}} to={`/about`}>About </NavLink></div>
                        <div><NavLink activeStyle={{color: "FireBrick"}} to={`/team`}>Team </NavLink></div>
                        <div style={{fontSize:"1em"}} > <span >Practices </span>
                                <ul>
                                    <li style={{fontSize:".8em"}}><NavLink activeStyle={{color: "FireBrick"}} to={`/chinapractice`}>China Practice </NavLink></li>
                                    <li style={{fontSize:".8em"}}> <NavLink activeStyle={{color: "FireBrick"}} to={`/businesslitigation`}>Business Litigation</NavLink></li>
                                    <li style={{fontSize:".8em"}}><NavLink activeStyle={{color: "FireBrick"}} to={`/iplitigation`}>Intellectual Property Litigation</NavLink></li>
                                    <li style={{fontSize:".8em"}}> <NavLink activeStyle={{color: "FireBrick"}} to={`/criminaldefense`}>Criminal Defense and Investigations</NavLink></li>
                                    <li style={{fontSize:".8em"}} > <NavLink activeStyle={{color: "FireBrick"}} to={`/outsidegc`}>IP Opinions and Counseling</NavLink></li>
                                    <li style={{fontSize:".8em"}} > <NavLink activeStyle={{color: "FireBrick"}} to={`/probono`}>Pro Bono</NavLink></li>
                                </ul></div>
                        <div><NavLink activeStyle={{color: "FireBrick"}} to={`/contact`}>Contact </NavLink></div>
                        <div><NavLink activeStyle={{color: "FireBrick"}} to={`/news`}>News </NavLink></div>
                    </Menu>
                    <div style={{ top: "0", left: "0", width: "15%", height:"100%"}}></div>

                    <div style={{width: "85%", height: "100%", float: "left", padding:"10px",display: "inline-block",verticalAlign: "middle"}}>
                        <NavLink activeStyle={{color: "FireBrick"}} to={`/home`}><img alt="Morrow Firm" style={{maxHeight:"3.5em", maxWidth: "100%"}}  src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/TMF.jpeg?alt=media&token=6a49739e-3805-4140-b280-39e73fcad4ac" /></NavLink>
                        </div>
                </div>}






                {this.state.width>=500 && <div className="bb" style={{width:"100%", height: "6vw", padding: 0}}>
                        <div style={{width: "92%", margin: "auto", display: "flex"}}>
                            <div style={{width: "25%", height: "100%", float: "left", padding:"6px",display: "inline-block", verticalAlign: "middle"}}>

                                  <NavLink activeStyle={{color: "FireBrick"}} to={`/home`}><img alt="Morrow Firm" style={{width: "100%", padding:4,  maxHeight:"100%" }} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/TMF.jpeg?alt=media&token=6a49739e-3805-4140-b280-39e73fcad4ac"/></NavLink>


                            </div>
                            <div style={{width: "75%", float: "right" , height: "100%", margin: "auto", display: "flex", fontFamily:"Raleway, sans-serif"}}>
                                <div style={{fontSize: "1.5vw", width: "37%", }} ></div>
                                <div style={{fontSize: "1.5vw", width: "10%", }} className="dropdown"> <span ><NavLink activeStyle={{color: "FireBrick"}} to={`/home`}>Home </NavLink></span>
                                </div>
                                <div style={{fontSize: "1.5vw", width: "10%"}}  className="dropdown"> <NavLink activeStyle={{color: "FireBrick"}} to={`/about`}>About </NavLink></div>
                                <div style={{fontSize: "1.5vw", width: "10%"}}  className="dropdown"><NavLink activeStyle={{color: "FireBrick"}} to={`/team`}>Team </NavLink></div>
                                <div style={{fontSize: "1.5vw", width: "12%"}} className="dropdown" > <span >Practices </span>
                                    <div className="dropdown-content">
                                        <NavLink activeStyle={{color: "FireBrick"}} to={`/chinapractice`}>China Practice </NavLink>
                                        <NavLink activeStyle={{color: "FireBrick"}} to={`/businesslitigation`}>Business Litigation</NavLink>

                                        <NavLink activeStyle={{color: "FireBrick"}} to={`/iplitigation`}>Intellectual Property Litigation</NavLink>
                                       <NavLink activeStyle={{color: "FireBrick"}} to={`/criminaldefense`}>Criminal Defense and Investigations</NavLink>
                                        <NavLink activeStyle={{color: "FireBrick"}} to={`/outsidegc`}>IP Opinions and Counseling</NavLink>
                                        <NavLink activeStyle={{color: "FireBrick"}} to={`/probono`}>Pro Bono</NavLink>
                                    </div>
                                </div>
                                <div style={{fontSize: "1.5vw", width: "10%"}}  className="dropdown"><NavLink activeStyle={{color: "FireBrick"}} to={`/news`}>News </NavLink></div>
                                <div style={{fontSize: "1.5vw", width: "10%"}} className="dropdown"  ><NavLink activeStyle={{color: "FireBrick"}} to={`/contact`}>Contact </NavLink></div>
                            </div>
                        </div>
                    </div>}</div>}




                {this.state.setLang==="zh" &&  <div> {this.state.width<500 && <div  style={{margin:"auto", display: "flex"}}>

                    <Menu styles={ styles } >
                        <div> <NavLink activeStyle={{color: "FireBrick"}} to={`/home`}>主页 </NavLink></div>
                        <div> <NavLink activeStyle={{color: "FireBrick"}} to={`/about`}>关于我们 </NavLink></div>
                        <div><NavLink activeStyle={{color: "FireBrick"}} to={`/team`}>团队简介 </NavLink></div>
                        <div style={{fontSize:"1em"}} > <span >业务领域 </span>
                            <ul>
                                <li style={{fontSize:".8em"}}><NavLink activeStyle={{color: "FireBrick"}} to={`/chinapractice`}>中国业务 </NavLink></li>
                                <li style={{fontSize:".8em"}}> <NavLink activeStyle={{color: "FireBrick"}} to={`/businesslitigation`}>商业诉讼与纠纷</NavLink></li>

                                <li style={{fontSize:".8em"}}><NavLink activeStyle={{color: "FireBrick"}} to={`/iplitigation`}>知识产权诉讼与纠纷</NavLink></li>
                                <li style={{fontSize:".8em"}}> <NavLink activeStyle={{color: "FireBrick"}} to={`/criminaldefense`}>白领犯罪辩护与调查</NavLink></li>
                                <li style={{fontSize:".8em"}} > <NavLink activeStyle={{color: "FireBrick"}} to={`/outsidegc`}>知识产权法律意见和咨询</NavLink></li>
                                <li style={{fontSize:".8em"}} > <NavLink activeStyle={{color: "FireBrick"}} to={`/probono`}>法律援助</NavLink></li>
                            </ul></div>
                        <div><NavLink activeStyle={{color: "FireBrick"}} to={`/contact`}>联系我们  </NavLink></div>
                    </Menu>
                    <div style={{ top: "0", left: "0", width: "15%", height:"100%"}}></div>

                    <div style={{width: "85%", height: "100%", float: "left", padding:"4px",display: "inline-block",verticalAlign: "middle"}}>

                        <NavLink activeStyle={{color: "FireBrick"}} to={`/home`}><img alt="Morrow Firm" style={{width: "100%"}} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/logocn.png?alt=media&token=5f74f5f1-61c4-4d11-a089-a3392def8e79"/></NavLink>
                    </div>
                </div>}






                    {this.state.width>=500 && <div className="bb" style={{width:"100%", padding: 0, height: "6vw",}}>
                        <div style={{width: "92%", margin: "auto", display: "flex"}}>
                            <div style={{width: "25%",  height: "100%", float: "left", padding:"4px",display: "inline-block", verticalAlign: "middle"}}>


                                   <NavLink activeStyle={{color: "FireBrick"}} to={`/home`}><img alt="Morrow Firm" style={{width: "100%",  }} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/logocn.png?alt=media&token=5f74f5f1-61c4-4d11-a089-a3392def8e79"/></NavLink>
                            </div>
                            <div style={{width: "75%", float: "right" , height: "100%", margin: "auto", display: "flex", fontFamily:"Raleway, sans-serif"}}>
                                <div style={{fontSize: "1.5vw", width: "45%", }} ></div>
                                <div style={{fontSize: "1.5vw", width: "7%", }} className="dropdown"> <span ><NavLink activeStyle={{color: "FireBrick"}} to={`/home`}>主页 </NavLink></span>
                                </div>
                                <div style={{fontSize: "1.5vw", width: "11%"}}  className="dropdown"> <NavLink activeStyle={{color: "FireBrick"}} to={`/about`}>关于我们 </NavLink></div>
                                <div style={{fontSize: "1.5vw", width: "10%"}}  className="dropdown"><NavLink activeStyle={{color: "FireBrick"}} to={`/team`}>团队简介 </NavLink></div>
                                <div style={{fontSize: "1.5vw", width: "11%"}} className="dropdown" > <span >业务领域 </span>
                                    <div className="dropdown-content">
                                       <NavLink activeStyle={{color: "FireBrick"}} to={`/chinapractice`}>中国业务</NavLink>
                                        <NavLink activeStyle={{color: "FireBrick"}} to={`/businesslitigation`}>商业诉讼与纠纷</NavLink>

                                        <NavLink activeStyle={{color: "FireBrick"}} to={`/iplitigation`}>知识产权诉讼与纠纷</NavLink>
                                        <NavLink activeStyle={{color: "FireBrick"}} to={`/criminaldefense`}>白领犯罪辩护与调查</NavLink>
                                        <NavLink activeStyle={{color: "FireBrick"}} to={`/outsidegc`}>知识产权法律意见和咨询</NavLink>
                                        <NavLink activeStyle={{color: "FireBrick"}} to={`/probono`}>法律援助</NavLink>
                                    </div>
                                </div>
                                <div style={{fontSize: "1.5vw", width: "12%"}} className="dropdown"  ><NavLink activeStyle={{color: "FireBrick"}} to={`/contact`}>联系我们 </NavLink></div>
                            </div>
                        </div>
                    </div>}</div>}




{this.state.setLang==="en" && <div>
                {this.state.width>=500  &&  <div style={{fontSize: "1.2vw", position:"fixed", top:0, right: 0, width: "10%"}} className="dropdown"  ><span onClick={ ()=>{this.setLang("en")}}>English</span> | <span onClick={ ()=>{this.setLang("zh")}}>中文</span></div>}
                {this.state.width<500  &&  <div style={{fontSize: "4vw", position:"fixed", top:50, left: 0, }} className="dropdown"  ><span onClick={ ()=>{this.setLang("en")}}>English</span> | <span onClick={ ()=>{this.setLang("zh")}}>中文</span></div>}
</div>}
                {this.state.setLang==="zh" && <div>
                    {this.state.width>=500  &&  <div style={{fontSize: "1.2vw", position:"fixed", top:0, right: 0, width: "10%"}} className="dropdown"  ><span onClick={ ()=>{this.setLang("en")}}>English</span> | <span onClick={ ()=>{this.setLang("zh")}}>中文</span></div>}
                    {this.state.width<500  &&  <div style={{fontSize: "4vw", position:"fixed", top:60, left: 0, }} className="dropdown"  ><span onClick={ ()=>{this.setLang("en")}}>English</span> | <span onClick={ ()=>{this.setLang("zh")}}>中文</span></div>}
                </div>}

            </div>




        )
    }





    render() {





        return (

            <div style={{width:"100%"}}>



                {this.renderMenu()}








            </div>


        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang };
}

export default connect(mapStateToProps, {  getUser, setLang })(NavBar2);



// WEBPACK FOOTER //
// ./src/Containers/NavBar2.js